import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import CasualtyMonitorServices from "./casualty_monitor.services";
import WFlowEmpleadosServices from "../../on&offBoarning/Mantenimientos/WorkFlowEmp/wFlowEmpleados.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCasualtyMonitor = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CASUALTY_MONITOR,
      payload: true,
    });
    const resp = await CasualtyMonitorServices.getCasualtyMonitor(filters);
    dispatch({
      type: actions.GET_CASUALTY_MONITOR,
      payload: {
        casualtyMonitor: resp.data.data,
        casualtyMonitorLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.CASUALTY_MONITOR_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.CASUALTY_MONITOR_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.GET_CASUALTY_MONITOR,
      payload: {
        casualtyMonitor: [],
        casualtyMonitorLength: 0,
      },
    });
  } finally {
    dispatch({
      type: actions.LOADING_CASUALTY_MONITOR,
      payload: false,
    });
  }
};

export const workflowAssign = (reqWF, setRespSelected, setTempSelected, setIsSubmit, handleClose) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CASUALTY_MONITOR,
      payload: true,
    });
    await WFlowEmpleadosServices.saveWorkFlowEmp(reqWF);
    // const _resp = await CasualtyMonitorServices.workflowAssign(id,data);
    // await CasualtyMonitorServices.workflowAssign(id,{
    //   ..._resp.data,
    //   off_bording: _reqWF.data.resultado[0].workflow
    // });
    const { casualtyMonitor, casualtyMonitorLength } = getState().casualtyMonitor;
    // casualtyMonitor[index] = resp.data;
    // casualtyMonitor.splice(index, 1);
    dispatch({
      type: actions.GET_CASUALTY_MONITOR,
      payload: {
        casualtyMonitor: casualtyMonitor,
        casualtyMonitorLength: casualtyMonitorLength - 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setRespSelected();
    setTempSelected();
    setIsSubmit();
    handleClose(false);
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CASUALTY_MONITOR,
      payload: false,
    });
  }
};
